<template>
  <div class="w-full h-full flex justify-center items-center">
    <ElEmpty :description="text" />
  </div>
</template>

<script setup>
import { ElEmpty } from "element-plus";
import { computed } from "vue";
import { defineProps } from "vue";

const props = defineProps({
  text: {
    type: String,
  },
});

const text = computed(() => props.text);
</script>

<style scoped></style>
